import React, { useState, useEffect } from "react";
import { Container } from "reactstrap";
import CustomButton from "components/CustomButton";
import { FormSelects, FormInputs } from "components/FormInputSelect";
import { TOOLBAR_SELECT_STYLES } from "components/toolbarSelectStyles";
import { Bell, Sort, ChevronUp, ChevronDown, MusicSecondary, MusicYellow } from "assets";
import { BiFilter, BiPlus, BiDownload } from "react-icons/bi";
import { FiSearch } from "react-icons/fi";
import InfoCard from "pages/dashboard/InfoCard";
import Table from "components/Table";
import { API_GET_MAMBOO } from "services";
import Pagination from "components/Pagination";
import { useNavigate } from "react-router-dom";
import { getCookie } from "services/cookies";
import ModalImport from "components/ModalImport";
import useLoginStore from "hooks/useLoginStore";

const Pendapatan = () => {
  const {isVerified} = useLoginStore()
  const [isShow, setIsShow] = useState({
    label: "5",
    value: 5,
  });
  const [dataTable, setDataTable] = useState([]);
  const [dataSinkronisasi, setDataSinkronisasi] = useState({});
  const [dataMechanical, setDataMechanical] = useState({});
  const [dataPerforming, setDataPerforming] = useState({});
  const [dataDemd, setDataDemd] = useState({});
  const [isValue, setIsValue] = useState("01");
  const [isPage, setIsPage] = useState(1);
  const [isTotalPage, setIsTotalPage] = useState();
  const title = ['Penyanyi', 'Songwriter Lainnya', 'Periode Pemakaian', 'Produk', 'Keterangan']
  const navigate = useNavigate();
  const isPencipta = getCookie("publisher") == 3;

  const formatDate = (cell) => {
    const startDate = new Date(cell.split(" - ")[0]);
    const endDate = new Date(cell.split(" - ")[1]);

    const options = { year: "2-digit", month: "short", day: "2-digit" };
    const startFormatted = startDate.toLocaleDateString("id-ID", options).replace(",", "");
    const endFormatted = endDate.toLocaleDateString("id-ID", options).replace(",", "");

    return startFormatted + " - " + endFormatted;
  }

  const getDetail = async (id) => {
    await API_GET_MAMBOO.dynamic.getDetailTransaksi(id)
      .then((res) => {
        navigate('/transaksi/detail', { state: { detailTransaksi: [{ ...res[0] }] } })
      })
  }

  const formatCurrency = new Intl.NumberFormat("id-ID", {
    style: "currency",
    currency: "IDR",
    minimumFractionDigits: 0,
  });

  let stylesText = {
    color: 'var(--brand-contrast)'
  }

  let stylesBackground = {
    cursor: 'pointer',
    backgroundColor: 'var(--brand)'
  }

  let stylesBlackText = {
    color: 'var(--text-secondary)'
  }

  let stylesWhiteBackground = {
    cursor: 'pointer',
    backgroundColor: 'var(--surface-1)'
  }

  const infoCardContent = [
    {
      CardIcon: isValue === dataMechanical.value ? MusicYellow : MusicSecondary,
      title: 'Mechanical Rights',
      tooltip:
        "Hak penggandaan dan reproduksi karya musik ke dalam format rekaman, baik media fisik (CD, vinyl) maupun unduhan digital resmi.",
      data: formatCurrency.format(dataMechanical.sum),
      key: dataMechanical.value,
      styleBackground: isValue === dataMechanical.value ? stylesBackground : stylesWhiteBackground,
      styleText: isValue === dataMechanical.value ? stylesText : stylesBlackText
    },
    // Performing Rights tidak ditampilkan untuk pencipta (role_code 3).
    ...(isPencipta ? [] : [{
      CardIcon: isValue === dataPerforming.value ? MusicYellow : MusicSecondary,
      title: "Performing Rights",
      data: formatCurrency.format(dataPerforming.sum),
      key: dataPerforming.value,
      styleBackground: isValue === dataPerforming.value ? stylesBackground : stylesWhiteBackground,
      styleText: isValue === dataPerforming.value ? stylesText : stylesBlackText
    }]),
    {
      CardIcon: isValue === dataSinkronisasi.value ? MusicYellow : MusicSecondary,
      title: "Synchronization Rights",
      tooltip:
        "Hak lisensi penggunaan musik yang diselaraskan dengan media visual, seperti film, serial TV, iklan komersial, dan video game.",
      data: formatCurrency.format(dataSinkronisasi.sum),
      key: dataSinkronisasi.value,
      styleBackground: isValue === dataSinkronisasi.value ? stylesBackground : stylesWhiteBackground,
      styleText: isValue === dataSinkronisasi.value ? stylesText : stylesBlackText
    },
    {
      CardIcon: isValue === dataDemd.value ? MusicYellow : MusicSecondary,
      title: "Digital Rights (DEMD)",
      tooltip:
        "Royalti atas pemanfaatan dan distribusi komersial lagu di platform digital (streaming musik, DSP seperti Spotify/Apple Music, video streaming, dan unduhan digital).",
      data: formatCurrency.format(dataDemd.sum),
      key: dataDemd.value,
      styleBackground: isValue === dataDemd.value ? stylesBackground : stylesWhiteBackground,
      styleText: isValue === dataDemd.value ? stylesText : stylesBlackText
    }
  ]

  const columnRefs = [
    {
      dataField: "song_title",
      text: (
        <>
          <span>Judul Lagu</span>
          <Sort />
        </>
      ),
      sort: true,
    },
    {
      dataField: "creator",
      text: (
        <>
          <span>Songwriter</span>
          <Sort />
        </>
      ),
      sort: true,
    },
    {
      dataField: "agreement_date",
      text: (
        <>
          <span>Tanggal Perjanjian</span>
          <Sort />
        </>
      ),
      sort: true,
      // formatter: (cell, row) => formatDate(cell)
    },
    {
      dataField: "client",
      text: (
        <>
        <span>Client</span>
        </>
      ),
    },
    {
      dataField: "total_transaction",
      text: (
        <>
        <span>Harga</span>
        </>
      ),
      formatter: (cell, row) => formatCurrency.format(cell),
    },
  ];

  const expandComponent = {
    renderer: row => (
      <div className='expand-container'>
        {row.expand && Object.keys(row.expand).map((item, i) => (
          < div className='expand-content' >
            <span className="expand-title" style={{ textTransform: 'capitalize', fontSize: "16px" }}>{title[i]}</span>
            <div className='expand-data'>
              {item !== "info" && item !== "period" && item !== "product" ?
                row.expand[item].map((val, i) => (
                  <span className='expand-text'>{val}</span>
                ))

                : <span className='expand-text'>{row.expand[item]}</span>}
              {i === (Object.keys(row.expand).length - 1) &&
                <CustomButton
                  label="Detail Laporan"
                  size="btn-sm"
                  className="btn-full button-import mt-5 align-self-center ms-4"
                  onClick={() => getDetail(row.transaction_id)}
                />
              }
            </div>
          </div>
        ))
        }
      </div >
    ),
    onlyOneExpanding: true,
    parentClassName: (isExpanded, row, rowIndex) => {
      return 'parent-expand'
    },
    className: (isExpanded, row, rowIndex) => {
      return 'row-expand'
    },
    expandByColumnOnly: true,
    showExpandColumn: true,
    expandColumnPosition: 'right',
    expandHeaderColumnRenderer: () => "Detail",
    expandColumnRenderer: ({ expanded }) => {
      if (expanded) {
        return (
          <ChevronUp />
        )
      } else {
        return (
          <ChevronDown />
        )
      }
    }
  }

  const options = [
    {
      label: "5",
      value: 5,
    },
    {
      label: "10",
      value: 10,
    },
    {
      label: "25",
      value: 25,
    },
    {
      label: "50",
      value: 50,
    },
  ];

  const onChangeSelect = (e) => {
    setIsShow(e.value);
  };

    const handleOnClick = (value) => {
    setIsValue(value)
  }

  const handleClickNumber = (page) => {
    if(isValue) {
      API_GET_MAMBOO.dynamic
        .getIncomeReport(isValue, page, isShow.value)
        .then((response) => {
          let totalPage = Math.ceil(response.total / isShow.value)
          response.data.forEach((data) => data.id = data.transaction_id)
          setDataTable(response.data);
          setIsTotalPage(totalPage);
          setIsPage(page);
        })
        .catch((err) => {
          setDataTable([]);
        });
    }
  }

  const modalContentVerified = () => {
    return (
      <div className="custom-modal-body">
        <span style={{fontSize: 'large', fontWeight: 'bold', textAlign: 'center'}}>Segera Verifikasi Publisher</span>
          <span style={{fontSize: 'small', fontSize: '15px'}}>Buka semua fitur yang ada dengan cara melengkapi dokumen yang ada dan nantinya akan kami verifikasi terlebih dahulu.</span>
      </div>
    )
  }

  useEffect(() => {
    if(isValue) {
      API_GET_MAMBOO.dynamic
        .getIncomeReport(isValue, isPage, isShow.value)
        .then((response) => {
          let totalPage = Math.ceil(response.total / isShow.value)
          response.data.forEach((data) => data.id = data.transaction_id)
          setDataTable(response.data);
          setIsTotalPage(totalPage)
        })
        .catch((err) => {
          setDataTable([]);
        });
    }

    API_GET_MAMBOO.dynamic
      .getIncomeDashboard()
      .then((response) => {
        response.find((val) => {
          if(val.category_code === "01") {
            setDataSinkronisasi({
              sum: val.sum,
              value: val.category_code
            })
          }
          if(val.category_code === "02") {
            setDataDemd({
              sum: val.sum,
              value: val.category_code
            })
          }
          if(val.category_code === "03") {
            setDataMechanical({
              sum: val.sum,
              value: val.category_code
            })
          }
          if(val.category_code === "04") {
            setDataPerforming({
              sum: val.sum,
              value: val.category_code
            })
          }
        })
      })
      .catch((err) => {
        setDataSinkronisasi({})
        setDataDemd({})
        setDataMechanical({})
        setDataPerforming({})
      });
  }, [isValue, isShow]);

  return (
    <>
      <Container fluid className="content-pencipta">
        <div className="header-content">
          <div className="pencipta-header">
            <h1>Laporan Pendapatan</h1>
            <span>Deskripsi</span>
          </div>
          <div className="icon-wrapper">
            <Bell />
          </div>
        </div>
        <div className="tabs-filters">
          <div className="frame-filters">
            <div className="frame-sub-filters">
              <div className="frame-cari-nama">
                <div className="box-text-cari-nama">
                  <span className="text-cari-nama">Cari Judul</span>
                </div>
                <FormInputs
                  placeholder="Masukkan Judul Lagu"
                  className="frame-cari-nama"
                />
                <div className="frame-search">
                  <FiSearch />
                </div>
              </div>
            </div>
            <CustomButton
              label="Filter"
              LabelIcon={BiFilter}
              iconPosition="left"
              size="md"
              className="button-filter"
            />
            {isPencipta ? null : (
              <>
                <CustomButton
                  label="Download"
                  color="primary-btn"
                  size="md"
                  iconPosition="left"
                  LabelIcon={BiDownload}
                  className="button-add-transaksi"
                  // onClick={(e) => {
                  //   navigate("/transaksi/create")
                  // }}
                />
                {isValue === dataPerforming.value && (
                  <CustomButton
                    label="Upload"
                    color="primary-btn"
                    size="md"
                    iconPosition="left"
                    LabelIcon={BiPlus}
                    className="button-add-transaksi"
                    // onClick={(e) => {
                    //   navigate("/transaksi/create")
                    // }}
                  />
                )}
              </>
            )}
          </div>
        </div>

        <div className="content-container" style={{ marginBottom: "15px" }}>
          <div className="info-card-container">
            {infoCardContent.map((content) => (
              <InfoCard
                content={content}
                key={content.key}
                onClick={() => handleOnClick(content.key)}
              />
            ))}
          </div>
        </div>

        <Table
          columnRefs={columnRefs}
          dataTable={dataTable}
          expandRow={expandComponent}
          noDataText="Belum ada Laporan"
        />
        {/* Satu baris kaki tabel: pemilih jumlah baris di kiri, lalu
            keterangan halaman dan navigasinya. Ketiganya mengatur paginasi,
            jadi dikumpulkan dalam satu baris. Garis atas dan padding kiri
            dipindah ke pembungkus ini (lihat .table-footer di pencipta.scss)
            supaya garisnya membentang penuh, bukan mulai setelah "Show". */}
        <div className="table-footer">
          <div className="table-footer-filters">
            <p className="text-show">Show :</p>
            <FormSelects
              options={options}
              onChange={onChangeSelect}
              defaultValue={isShow}
              value={isShow}
              styles={TOOLBAR_SELECT_STYLES}
            />
          </div>
          <Pagination
            isTotalPage={isTotalPage}
            isPage={isPage}
            handleClickNumber={handleClickNumber}
            pageToShow={6}
          />
        </div>
      </Container>
      <ModalImport
        modal={!isVerified}
        title=""
        body={modalContentVerified()}
        centered={true}
        buttonLabel={"Go to Profile"}
        onClick={() => navigate("/profile")}
      />
    </>
  );
};

export default Pendapatan;
